module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/social/medium-3e98f6f2b49754b5da5dc4e39871626f.svg";